var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFactrura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.66168H23C23.2652 6.66168 23.5196 6.55932 23.7071 6.37712C23.8946 6.19493 24 5.94782 24 5.69015C24 5.43249 23.8946 5.18538 23.7071 5.00318C23.5196 4.82098 23.2652 4.71863 23 4.71863H7C6.73478 4.71863 6.48043 4.82098 6.29289 5.00318C6.10536 5.18538 6 5.43249 6 5.69015C6 5.94782 6.10536 6.19493 6.29289 6.37712C6.48043 6.55932 6.73478 6.66168 7 6.66168Z",
    fill: "#1B4354"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.5193H7C6.73478 11.5193 6.48043 11.6216 6.29289 11.8038C6.10536 11.986 6 12.2331 6 12.4908C6 12.7485 6.10536 12.9956 6.29289 13.1778C6.48043 13.36 6.73478 13.4623 7 13.4623H23C23.2652 13.4623 23.5196 13.36 23.7071 13.1778C23.8946 12.9956 24 12.7485 24 12.4908C24 12.2331 23.8946 11.986 23.7071 11.8038C23.5196 11.6216 23.2652 11.5193 23 11.5193Z",
    fill: "#1B4354"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18.3199H7C6.73478 18.3199 6.48043 18.4223 6.29289 18.6045C6.10536 18.7867 6 19.0338 6 19.2915C6 19.5491 6.10536 19.7962 6.29289 19.9784C6.48043 20.1606 6.73478 20.263 7 20.263H23C23.2652 20.263 23.5196 20.1606 23.7071 19.9784C23.8946 19.7962 24 19.5491 24 19.2915C24 19.0338 23.8946 18.7867 23.7071 18.6045C23.5196 18.4223 23.2652 18.3199 23 18.3199Z",
    fill: "#1B4354"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.63317C3.10457 7.63317 4 6.76324 4 5.69012C4 4.617 3.10457 3.74707 2 3.74707C0.89543 3.74707 0 4.617 0 5.69012C0 6.76324 0.89543 7.63317 2 7.63317Z",
    fill: "#1B4354"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.4339C3.10457 14.4339 4 13.564 4 12.4908C4 11.4177 3.10457 10.5478 2 10.5478C0.89543 10.5478 0 11.4177 0 12.4908C0 13.564 0.89543 14.4339 2 14.4339Z",
    fill: "#1B4354"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.2345C3.10457 21.2345 4 20.3646 4 19.2915C4 18.2184 3.10457 17.3484 2 17.3484C0.89543 17.3484 0 18.2184 0 19.2915C0 20.3646 0.89543 21.2345 2 21.2345Z",
    fill: "#1B4354"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFactrura);
export default __webpack_public_path__ + "static/media/ico_factrura.ad406fea45459d763ca3fde5516782da.svg";
export { ForwardRef as ReactComponent };